"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWander = doWander;
const board_1 = require("@creature-chess/board");
const StandardTargetProvider_1 = require("../../../targeting/provider/StandardTargetProvider");
const getTargetAttackPositions_1 = require("../../../targeting/utils/getTargetAttackPositions");
const targetProvider = new StandardTargetProvider_1.StandardTargetProvider();
function findBestState(currentTurn, board, pieceRegistry, pieceId, { combatStore, creatures }) {
    const combatState = combatStore.getPiece(pieceId);
    if (combatState.canAttackAtTurn <= currentTurn) {
        const targetId = targetProvider.getTarget(board, pieceRegistry, combatStore, creatures, pieceId);
        if (targetId) {
            return { type: "attacking", payload: { targetId } };
        }
    }
    return { type: "wandering" };
}
function doWander(currentTurn, state, board, pieceRegistry, pieceId, stores) {
    // TODO search for a better state here and return early
    const bestState = findBestState(currentTurn, board, pieceRegistry, pieceId, stores);
    const { combatStore } = stores;
    if (bestState.type !== "wandering") {
        return [bestState];
    }
    const combatState = combatStore.getPiece(pieceId);
    // if the piece can't move yet, don't do anything
    if ((combatState.canMoveAtTurn || 0) > currentTurn) {
        return [state];
    }
    const piecePosition = board.getPiecePosition(pieceId);
    if (!piecePosition) {
        return [state];
    }
    const adjacentPositions = (0, getTargetAttackPositions_1.getTargetAttackPositions)({ width: board.width, height: board.height }, (0, board_1.packPosition)(piecePosition[0], piecePosition[1]));
    const emptyPositions = adjacentPositions.filter((p) => board.getPieceIdAtPosition((0, board_1.unpackX)(p), (0, board_1.unpackY)(p)) === null);
    // no empty positions, so don't do anything
    if (emptyPositions.length === 0) {
        return [state];
    }
    const moveAction = {
        type: "move",
        payload: emptyPositions[0],
    };
    return [state, [moveAction]];
}
